module.exports = __webpack_public_path__ + "img/logo-wide-dark.67178b61.svg";